import React from 'react'

function PrivacyFr() {
  return (
    <div className="terms">
      <div className="container pad">
        <h1 className="center">Politique de Confidentialité Créateurs</h1>
        <p>
          La protection de vos données personnelles est la priorité de Skeepers.
        </p>
        <p>
          La politique de confidentialité Créateurs (ci-après la «{' '}
          <b>Politique de Confidentialité Créateurs</b> ») a pour objectif de
          vous informer (les <b>« Créateurs »</b>) des traitements de vos
          données personnelles réalisés par Skeepers et de vos droits à ce titre
          dans le cadre de notre collaboration.
        </p>
        <p>
          Les « <b>données personnelles</b> » <b>(ci-après « Données »</b>) sont
          à comprendre comme toute information qui vous est propre (nom, prénom,
          âge, adresse, mail, numéro de téléphone etc.).
        </p>
        <p>
          Un « <b>traitement de données</b> » est une utilisation de vos
          Données, qui peut prendre toute forme (collecte, enregistrement,
          hébergement modification, transfert etc.).
        </p>
        <p>
          Tout terme spécifique à la protection des données personnelles
          (Responsable de traitement, Personne concernée etc.) est à entendre
          comme défini à l’article 4 du Règlement (UE) 2016/679 du Parlement
          Européen et du Conseil du 27 avril 2016 relatif à la protection des
          personnes physiques à l'égard du traitement des données à caractère
          personnel et à la libre circulation de ces données (dit « Règlement
          Général sur la Protection des Données », ci-après « <b>RGPD</b> »).
        </p>
        <p>
          <b>La Politique de Confidentialité Créateurs</b> s’applique dès votre
          accès au site Skeepers depuis l'adresse URL suivante :
          https://www.octoly.com/ (le « <b>Site</b> »), elle régit l'utilisation
          qui en est fait, jusqu’à l'ensemble des services proposés par la
          plateforme Skeepers ou en lien avec celle-ci (la « <b>Plateforme</b>{' '}
          »). La Plateforme est accessible aux Créateurs qui se sont inscrits à
          l'adresse URL suivante : https://app.im.skeepers.io/creators/sign_up .
        </p>
        <p>
          Concernant les prospects, les marques clientes (« <b>Marques</b>
          ») qui se sont abonnées à la Plateforme en concluant un contrat avec
          Skeepers, ainsi que les fournisseurs, ces derniers doivent se reporter
          à la Politique de Confidentialité suivante :
          https://skeepers.io/fr/politique-de-confidentialite2/ . En effet, par
          souci d’offrir une meilleure visibilité et compréhension de la
          collecte des données et des traitements opérés par Skeepers, ou par
          l’une de ses filiales, à l’occasion de la délivrance de ses Services
          (ici « Influencer Marketing »), l’information des Créateurs et des
          Clients est scindée en deux documents.
        </p>
        <p>
          Aux fins de la présente Politique de Confidentialité Créateurs, toute
          les références à « Skeepers » ou « Groupe Skeepers » incluent
          également ses Filiales (toute entité contrôlée, directement ou
          indirectement, par le Groupe Skeepers), sauf indication contraire.
        </p>
        <p>
          La Politique de Confidentialité Créateurs pourra être modifiée pour
          tenir compte notamment de l’évolution des traitements des Données mis
          en œuvre et de la législation applicable. Ainsi, les Créateurs sont
          invités à prendre connaissance de toute nouvelle version mise à
          disposition par Skeepers.
        </p>
        <h2 className="fs-30">1. Informations Générales</h2>
        <p>
          En accédant et/ou en utilisant le Site, la Plateforme et de manière
          globale les Services, vous consentez par la présente à l'ensemble des
          termes de la Politique de Confidentialité.
        </p>
        <p>
          L'accès au Site, à la Plateforme et l’utilisation des Services est
          interdit à tout mineur de moins de seize ans. Par conséquent, en
          accédant et en les utilisant les Services, vous déclarez et
          garantissez que vous avez plus de 16 ans si vous êtes un.e citoyen.ne
          européen.ne et plus de 13 ans si vous êtes un.e citoyen.ne
          américain.e. Si vous avez moins de l’âge requis, vous ne devez à aucun
          moment et d'aucune manière accéder ou utiliser les Services.
        </p>
        <h2 className="fs-30">
          2. Le Responsable de traitement et les Personnes concernées par cette
          Politique de Confidentialité
        </h2>
        <p>
          Skeepers, SAS au capital de 11 470 723 €, immatriculée au registre du
          commerce et des sociétés de Marseille sous le numéro 879 038 990, et
          dont le siège social est situé au 18-20 Avenue Robert Schuman, CS
          40494, 13002 Marseille, est titulaire du site Internet
          https://www.octoly.com/. Elle est composée des Solutions Ratings &amp;
          Reviews, Insight and Feedback Management, Insight Activation,
          Influencer Marketing (la Solution ici utilisée), Live Shopping et
          Consumer Videos. Elle est qualifiée de Responsable de traitements de
          Données, en tant que personne morale proposant à des Créateurs et des
          Marques de collaborer ensemble afin d’augmenter la visibilité des
          produits des Marques, via les comptes des Créateurs sur les réseaux
          sociaux. Elle est Responsable de traitement conjoint avec les Marques
          avec lesquelles elle collabore.
        </p>
        <p>
          Skeepers est soumise en cette qualité aux obligations imposées par la
          réglementation en vigueur en France et au sein de l’Union Européenne
          en matière de données à caractères personnelles, en particulier le
          Règlement Général sur la Protection des Données dit « <b>RGPD</b> »,
          la loi française (Loi Informatique et Libertés de 1978, dite «{' '}
          <b>LiL</b> ») et, de manière générale, avec toute Réglementation qui
          lui est applicable en matière de protection des Données (California
          Consumer Privacy Act – <b>CCPA</b>, California Privacy Rights Act –{' '}
          <b>CPRA</b>, etc.).
        </p>
        <p>
          Les Personnes concernées par les traitements des Données sont les
          Créateurs, incluant notamment les internautes naviguant sur le Site («
          Vous »).
        </p>
        <h2 className="fs-30">3. Origine des données</h2>
        <p>
          Nous pouvons recevoir vos Données à partir de différentes sources :
        </p>
        <p>
          <b>Depuis votre navigation sur le Site</b>: les Données concernant les
          matériels et les logiciels de votre ordinateur (« fingerprinting »)
          peuvent être collectées par Skeepers, sauf si vous avez manifesté
          votre opposition via le panneau de gestion des cookies et/ou par la
          configuration de votre navigateur web. Ces données peuvent inclure :
          votre adresse IP, le type de navigateur, les noms de domaine, les
          dates et heures d'accès et les adresses de site web à partir
          desquelles vous avez accédé au Site ainsi que les données d’usage de
          la plateforme (actions réalisées par les Créateurs au sein du site).
        </p>
        <p>
          <b>Lors de votre inscription ou abonnement à la Plateforme</b>:
          lorsque vous vous inscrivez ou que vous vous abonnez à la Plateforme,
          vous devez communiquer à Skeepers votre email, pays de résidence et
          date de naissance. Skeepers peut également collecter toute information
          démographique anonyme, ne vous étant pas propre, tel que votre âge ou
          votre sexe. Vous devez mettre à jour ces données et vous vous engagez
          à faire part de tout changement les concernant au service
          marketing/client sans délai. Par ailleurs, les échanges d’emails sont
          susceptibles d’être enregistrées et conservés afin d’améliorer la
          qualité de notre service client et de former nos collaborateurs.
        </p>
        <p>
          <b>Accès via des réseaux sociaux :</b> si vous accédez ou vous
          identifiez sur le Site et/ou sur la Plateforme via un réseau social ou
          tout autre service, ou si vous connectez le Site et/ou la Plateforme à
          un réseau social ou à tout autre service, les informations que
          Skeepers collecte peuvent également inclure votre identifiant ou le
          nom d'utilisateur associé audit réseau social, toute information ou
          contenu que vous avez autorisé le réseau social à partager avec
          Skeepers, telle que votre photo de profil, votre adresse email ou
          encore la liste de vos amis, et de manière générale toute information
          que vous avez rendue publique via ces réseaux sociaux. Lorsque vous
          accédez au Site et/ou à la Plateforme via les réseaux sociaux ou
          lorsque vous connectez le Site et/ou la Plateforme à un réseau social,
          vous autorisez Skeepers à collecter, stocker et utiliser ces
          informations pour l'exécution des Services.
        </p>
        <p>
          Pour plus d’informations sur les Données Réseaux Sociaux, voir
          l’article 6 de la Politique de Confidentialité.
        </p>
        <p>
          Les Données ne seront pas rendues publiques à moins que vous les
          partagiez à partir de votre compte Skeepers.
        </p>
        <p>
          <b>
            Vous pouvez connecter votre compte Skeepers à d'autres comptes tiers
          </b>
          . En connectant votre compte Skeepers à d'autres comptes tiers via des
          Interfaces de Programmation Applicatives (Application Performing
          interface, ou API) comme Google, Youtube, Facebook, Twitter, TikTok ou
          Instagram, vous reconnaissez et acceptez une communication en continue
          d'informations vous concernant à d'autres parties (en accord avec les
          paramètres de confidentialité que vous avez définis sur ces sites
          tiers). Si vous ne souhaitez pas que vos Données soient ainsi
          partagées, n'utilisez pas cette fonctionnalité. Vous pouvez
          déconnecter votre Compte d'un compte tiers à tout moment. Vous pouvez
          apprendre à déconnecter vos comptes de tout site tiers en visitant la
          page d'information de votre Compte.
        </p>
        <p>
          Le Site et/ou la Plateforme peuvent renvoyer vers des sites gérés par
          des sociétés tierces sur lesquels Skeepers n'a aucun contrôle. Cette
          Politique de Confidentialité s'applique uniquement aux informations
          collectées par Skeepers via le Site ou les Services et ne s'applique
          pas à ces sites tiers, toutes Données que vous choisissez de dévoiler
          à ces sites tiers restant sous votre seule responsabilité. Skeepers ne
          surveille, ne contrôle et n'approuve en aucun cas la collecte de
          Données ni les pratiques de confidentialité des sociétés tierces.
          Skeepers vous encourage à consulter les politiques de confidentialité
          des sites sur lesquels vous choisissez de vous connecter, afin de
          comprendre de quelle manière ces sites collectent, utilisent et
          partagent vos informations.
        </p>
        <p>
          Skeepers n'est pas responsable des déclarations de confidentialité ni
          de tout autre contenu présent sur des sites autres que le Site et/ou
          la Plateforme.
        </p>
        <p>
          La politique de confidentialité de Youtube peut être consultée sur le
          lien suivant :{' '}
          <a
            target="_blank"
            rel="noreferrer"
            href="https://www.youtube.com/intl/ALL_fr/howyoutubeworks/user-settings/privacy/"
          >
            https://www.youtube.com/intl/ALL_fr/howyoutubeworks/user-settings/privacy/
          </a>
        </p>
        <p>
          La politique de confidentialité de Google peut être consultée sur le
          lien suivant :{' '}
          <a
            target="_blank"
            rel="noreferrer"
            href="http://www.google.com/policies/privacy"
          >
            http://www.google.com/policies/privacy
          </a>
        </p>
        <p>
          La politique de confidentialité de Facebook peut être consultée sur le
          lien suivant :{' '}
          <a
            target="_blank"
            rel="noreferrer"
            href="https://fr-fr.facebook.com/about/privacy"
          >
            https://fr-fr.facebook.com/about/privacy
          </a>
        </p>
        <p>
          La politique de confidentialité de Twitter peut être consultée sur le
          lien suivant :{' '}
          <a
            target="_blank"
            rel="noreferrer"
            href="https://twitter.com/fr/privacy"
          >
            https://twitter.com/fr/privacy
          </a>
        </p>
        <p>
          La politique de confidentialité d’Instagram peut être consultée sur le
          lien suivant :{' '}
          <a
            target="_blank"
            rel="noreferrer"
            href="https://privacycenter.instagram.com/policy"
          >
            https://privacycenter.instagram.com/policy
          </a>
        </p>
        <p>
          La politique de confidentialité de TikTok peut être consultée sur le
          lien suivant :{' '}
          <a
            target="_blank"
            rel="noreferrer"
            href="https://www.tiktok.com/legal/privacy-policy-eea?lang=fr"
          >
            https://www.tiktok.com/legal/privacy-policy-eea?lang=fr
          </a>
        </p>
        <p>
          <b>Cookies </b>: Skeepers recueille des données par le biais de cookie
          notamment via les services fournis par Google pour les données
          comportementales des internautes collectées par le recours aux Cookies
          et/ou traceurs.
        </p>
        <p>
          Pour plus d’informations, voir l’article 8 de la Privacy Policy : «
          Utilisation des Cookies/Publicité Ciblée ».
        </p>
        <p>
          Dans le cas où vous nous transmettez des Données relatives à une autre
          personne (ex : dans le cadre de recommandation), vous nous garantissez
          que, vous avez l’autorité pour consentir au traitement de Données en
          son nom, vous recevez en son nom toutes correspondances relatives à
          ses Données, et le cas échéant, vous consentez en son nom au transfert
          de ses Données à l’étranger.
        </p>
        <p>
          Nous ne collectons pas volontairement de Données relatives à des
          mineurs de moins de 13 ans si vous êtes un citoyen américain ou de 16
          ans si vous êtes un citoyen européen, néanmoins, si vous êtes un
          parent ou un tuteur légal de ce mineur et que vous pensez que nous
          détenons des Données sur ce mineur, vous pouvez obtenir la suppression
          des Données après avoir prouvé votre identité et votre autorité légale
          sur le mineur.
        </p>
        <h2 className="fs-30">
          4. Tableau récapitulatif des finalités, Données traitées, fondement du
          traitement, durée de conservation
        </h2>
        <p>
          Le tableau ci-dessous récapitule l’ensemble des traitements de Données
          en précisant pour chaque finalité : les Données concernées, et les
          personnes/services accédant à ces Données.
        </p>
        <table cellSpacing="0" cellPadding="0">
          <tbody>
            <tr>
              <td valign="middle"></td>
              <td colSpan="4" valign="middle">
                <p>
                  <b>Traitements de données Créateurs</b>
                </p>
              </td>
            </tr>
            <tr>
              <td valign="middle">
                <p>
                  <b>Contexte de la collecte</b>
                </p>
              </td>
              <td valign="middle">
                <p>
                  <b>Type de Données</b>
                </p>
              </td>
              <td valign="middle">
                <p>
                  <b>Finalités du traitement</b>
                </p>
              </td>
              <td valign="middle">
                <p>
                  <b>Fondements</b>
                </p>
              </td>
              <td valign="middle">
                <p>
                  <b>Personne/Services ayant accès aux Données</b>
                </p>
              </td>
            </tr>
            <tr>
              <td valign="middle">
                <p>
                  <b>Gestion du Site et de la Plateforme</b>
                </p>
              </td>
              <td valign="middle">
                <p>Cookies et autres traceurs</p>
              </td>
              <td valign="middle">
                <p>Fonctionnement du Site et de la Plateforme</p>
                <p>
                  Statistiques générales sur l’utilisation du Site et de la
                  Plateforme (mesures d’audience)
                </p>
                <p>Fingerprinting</p>
                <p>Dépôt de Cookies Tiers</p>
              </td>
              <td valign="middle">
                <p>Intérêt légitime</p>
                <p>Consentement</p>
              </td>
              <td valign="middle">
                <p>Service Marketing</p>
              </td>
            </tr>
            <tr>
              <td valign="middle">
                <p>
                  <b>
                    Gestion de la relation Créateurs (délivrance de la
                    prestation de collaboration)
                  </b>
                </p>
              </td>
              <td valign="middle">
                <p>
                  Obligatoires (obligation indiquée par un astérisque au moment
                  de la collecte) lors de l’inscription :
                </p>
                <ul>
                  <li>Courriel</li>
                  <li>Localisation (pays)</li>
                  <li>Date de naissance</li>
                </ul>
                <p>Obligatoires (pour accéder aux Campagnes consommateurs) :</p>
                <ul>
                  <li>Nom et Prénom</li>
                  <li>Genre</li>
                  <li>Adresse postale complète</li>
                  <li>Numéro de téléphone</li>
                </ul>
                <p>Obligatoires (pour accéder aux Campagnes influenceurs) :</p>
                <ul>
                  <li>
                    Données publiques accessibles sur le compte sur les réseaux
                    sociaux
                  </li>
                </ul>
                <p>Non Obligatoires :</p>
                <ul>
                  <li>Image (et voix si Vidéo)</li>
                  <li>Couleur de peau</li>
                  <li>Statut relationnel</li>
                  <li>Parentalité</li>
                  <li>Nombre d'enfants</li>
                  <li>Animaux</li>
                  <li>Habitudes d'achat</li>
                  <li>Type/ton de peau et préoccupations</li>
                  <li>Habitudes beauté</li>
                  <li>Couleur/type de cheveux</li>
                  <li>Revenus du ménage</li>
                  <li>Régime</li>
                  <li>Couleur des sourcils</li>
                  <li>Lunettes</li>
                  <li>Tailles</li>
                  <li>Mode de vie</li>
                  <li>Problèmes de peau</li>
                  <li>Marques préférées</li>
                </ul>
              </td>
              <td valign="middle">
                <p>
                  Gestion de votre compte Créateur (fourniture d’un accès à
                  l’espace Créateurs du Site, changement de mot de passe, etc.)
                </p>
                <p>Etablissement d’un contrat</p>
                <p>
                  Matching avec les campagnes en fonction de vos intérêts, votre
                  profil et des paramètres de vos médias sociaux
                </p>
                <p>Acceptation ou refus de votre candidature</p>
                <p>
                  Gestion de la livraison des produits de la Marque par Skeepers
                  ou par la Marque (dans cette dernière hypothèse, communication
                  de votre mail/sms afin de vous informer de la confirmation
                  d’envoi, de l’envoi, de la livraison)
                </p>
                <p>
                  Note d’évaluation par les Marques selon les prestations que
                  vous avez délivrées
                </p>
                <p>Enregistrement des échanges d’emails</p>
                <p>
                  Emails d'information de Skeepers<b> </b>(vous présentent nos
                  dernières fonctionnalités et vous tiennent au courant de nos
                  activités, etc.). Vous pouvez vous opposer à tout moment à
                  leur envoi depuis le lien de désinscription présent dans le
                  mail.
                </p>
                <p>
                  Emails de campagnes disponibles (vous présentent les campagnes
                  pour lesquelles vous avez accès). Consentement préalable, vous
                  pouvez vous opposer à tout moment à leur envoi depuis le lien
                  de désinscription présent dans le mail.
                </p>
                <p>
                  Enquête sur la qualité des prestations de service. Vous pouvez
                  vous opposer à tout moment à leur envoi depuis le lien de
                  désinscription présent dans le mail.
                </p>
                <p>Gestion de la fin de contrat.</p>
              </td>
              <td valign="middle">
                <p>Exécution du contrat</p>
                <p>Intérêt légitime</p>
                <p>Consentement</p>
              </td>
              <td valign="middle">
                <p>Responsable commercial</p>
                <p>Service comptable</p>
                <p>Marques collaborant avec le Créateur</p>
                <p>Sociétés de transport</p>
              </td>
            </tr>
            <tr>
              <td valign="middle">
                <p>
                  <b>Service de commande en ligne</b>
                </p>
              </td>
              <td valign="middle">
                <p>Nom et Prénom</p>
                <p>Courriel</p>
                <p>Adresse/localisation</p>
                <p>Numéro de téléphone</p>
              </td>
              <td valign="middle">
                <p>Proposer un service de commande en ligne sur le Site</p>
              </td>
              <td valign="middle">
                <p>Exécution du contrat</p>
              </td>
              <td valign="middle">
                <p>Responsable commercial</p>
                <p>Marques collaborant avec le Créateur</p>
              </td>
            </tr>
            <tr>
              <td valign="middle">
                <p>
                  <b>
                    Réponses aux demandes officielles d’autorités publiques ou
                    judiciaires habilitées à cet effet
                  </b>
                </p>
              </td>
              <td valign="middle">
                <p>Ensemble des Données</p>
              </td>
              <td valign="middle">
                <p>
                  Transmettre toutes données demandées par les autorités
                  publiques ou judiciaires
                </p>
              </td>
              <td valign="middle">
                <p>Obligation légale</p>
              </td>
              <td valign="middle">
                <p>Service comptable</p>
                <p>Service juridique</p>
                <p>Direction de Skeepers</p>
              </td>
            </tr>
            <tr>
              <td valign="middle">
                <p>
                  <b>
                    Détection, prévention et lutte contre la fraude et la
                    cybercriminalité
                  </b>
                </p>
              </td>
              <td valign="middle">
                <p>Ensemble des Données</p>
              </td>
              <td valign="middle">
                <p>
                  Collecter et traiter les données utiles afin de détecter,
                  prévenir, et lutter contre la fraude et la cybercriminalité
                </p>
              </td>
              <td valign="middle">
                <p>Obligation légale</p>
              </td>
              <td valign="middle">
                <p>Service comptable</p>
                <p>Service juridique</p>
                <p>Direction de Skeepers</p>
              </td>
            </tr>
            <tr>
              <td valign="middle">
                <p>
                  <b>Audit / acquisition</b>
                </p>
              </td>
              <td valign="middle">
                <p>Ensemble des Données</p>
              </td>
              <td valign="middle">
                <p>
                  Audit de la part de potentiels investisseurs, repreneurs,
                  acquéreurs
                </p>
                <p>Contrôles de la bonne application de nos process</p>
                <p>
                  Vérification du traitement des Données issues de la base de
                  données Créateurs
                </p>
              </td>
              <td valign="middle">
                <p>Intérêt légitime</p>
              </td>
              <td valign="middle">
                <p>Direction de Skeepers</p>
                <p>Prestataire extérieur</p>
                <p>Potentiel acquéreur</p>
              </td>
            </tr>
          </tbody>
        </table>
        <h2 className="fs-30">
          5. Données sensibles / “DO NOT USE MY SENSITIVE DATA” (CCPA/CPRA)
        </h2>
        <p>
          Les données sensibles forment une catégorie particulière des données
          personnelles.
        </p>
        <p>
          Ce sont des informations qui révèlent la prétendue origine raciale ou
          ethnique, les opinions politiques, les convictions religieuses ou
          philosophiques ou l'appartenance syndicale, ainsi que le traitement
          des données génétiques, des données biométriques aux fins d'identifier
          une personne physique de manière unique, des données concernant la
          santé ou des données concernant la vie sexuelle ou l'orientation
          sexuelle d'une personne physique.
        </p>
        <p>
          <b>
            Skeepers vous propose, à travers son questionnaire, de renseigner
            des données sensibles : votre couleur de peau (origine
            raciale/ethnique) ou vos problèmes de peau (potentiellement des
            données de santé).
          </b>
        </p>
        <p>
          <b>
            Vous n’êtes jamais obligé.e de les renseigner. En communiquant ces
            données, vous manifestez expressément votre volonté à ce qu’elles
            puissent servir d’éléments de pré-sélection par les Marques afin de
            cibler des Créateurs spécifiques pour leur(s) Campagne(s),
            uniquement sur la Plateforme. Vous pouvez changer d’avis à tout
            moment en paramétrant votre profil Créateur.
          </b>
        </p>
        <h2 className="fs-30">6. Données des réseaux sociaux</h2>
        <h3 className="fs-25">6.1. Données YouTube</h3>
        <p>
          En tant que Créateur, Vous reconnaissez et acceptez que le Site et/ou
          la Plateforme utilisent l’API de YouTube pour collecter et stocker les
          informations et les données disponibles dans Votre compte YouTube
          telles que décrites dans la Politique de confidentialité de YouTube
          <a
            target="_blank"
            rel="noreferrer"
            href="https://www.youtube.com/howyoutubeworks/user-settings/privacy/#your-data-in-youtube"
          >
            https://www.youtube.com/howyoutubeworks/user-settings/privacy/#your-data-in-youtube
          </a>
          (les <b>« Données YouTube »</b>).
        </p>
        <p>
          Les Données YouTube sont collectées afin de (i) vous permettre de
          participer aux Campagnes YouTube et pour (ii) extraire des
          statistiques concernant votre activité Skeepers. Vos Données YouTube
          sont stockées dans les serveurs Skeepers et peuvent être partagées
          avec des partenaires privilégiés de Skeepers à fin de statistiques.
        </p>
        <p>
          Vous pouvez révoquer l’accès de Skeepers à vos Données Youtube à tout
          moment via les réglages de sécurité de Google disponibles à l’adresse
          URL suivante:
          <a
            target="_blank"
            rel="noreferrer"
            href="https://security.google.com/settings/security/permissions"
          >
            https://security.google.com/settings/security/permissions
          </a>
        </p>
        <h3 className="fs-25">6.2. Données Meta (Instagram et Facebook)</h3>
        <p>
          En tant que Créateur, Vous reconnaissez et acceptez que Skeepers
          collecte et stocke les informations et les données disponibles dans
          votre compte Instagram ou page Facebook, selon l’hypothèse concernée,
          telles que décrites dans la Politique de confidentialité d'Instagram (
          <a
            target="_blank"
            rel="noreferrer"
            href="https://privacycenter.instagram.com/policy/?section_id=1-WhatInformationDoWe"
          >
            https://privacycenter.instagram.com/policy/?section_id=1-WhatInformationDoWe
          </a>
          ) et de Facebook (
          <a
            target="_blank"
            rel="noreferrer"
            href="https://www.facebook.com/privacy/policy/?entry_point=data_policy_redirect&amp;entry=0"
          >
            https://www.facebook.com/privacy/policy/?entry_point=data_policy_redirect&amp;entry=0
          </a>
          ) les « <b>Données Meta</b> ». En utilisant la Plateforme, Vous
          acceptez d’être lié.e aux Politiques de Confidentialité de Meta.
        </p>
        <p>
          Les Données Meta sont collectées afin de (i) vous permettre de
          participer aux Campagnes Instagram / Facebook et pour (ii) extraire
          des statistiques concernant votre activité Skeepers.
        </p>
        <p>
          Vos Données Meta sont stockées dans les serveurs Skeepers et peuvent
          être partagées avec vous et des partenaires privilégiés de Skeepers à
          fin d'amélioration de la relation marque-influenceur, d'amélioration
          de l'expérience utilisateur et de statistiques.
        </p>
        <p>
          Vous pouvez révoquer l’accès de Skeepers à vos Données Meta à tout
          moment via les réglages de sécurité disponibles à l’adresse URL
          suivante :
        </p>
        <ul>
          <li>
            pour Instagram :{' '}
            <a
              target="_blank"
              rel="noreferrer"
              href="https://help.instagram.com/536741816349927/?helpref=related_articles&amp;cms_id=536741816349927"
            >
              https://help.instagram.com/536741816349927/?helpref=related_articles&amp;cms_id=536741816349927
            </a>
          </li>
        </ul>
        <ul>
          <li>
            et pour Facebook :{' '}
            <a
              target="_blank"
              rel="noreferrer"
              href="https://www.facebook.com/help/792552774106866"
            >
              https://www.facebook.com/help/792552774106866
            </a>
          </li>
        </ul>
        <h3 className="fs-25">6.3. Données TikTok</h3>
        <p>
          En tant que Créateur, Vous reconnaissez et acceptez que Skeepers
          collecte et stocke les informations et les données disponibles dans
          votre compte TikTok telles que décrites dans la Politique de
          confidentialité de TikTok{' '}
          <a
            target="_blank"
            rel="noreferrer"
            href="https://www.tiktok.com/legal/page/eea/privacy-policy/en"
          >
            https://www.tiktok.com/legal/page/eea/privacy-policy/en
          </a>{' '}
          (les « <b>Données TikTok</b> »). En utilisant la Plateforme, Vous
          acceptez d’être lié.e à la Politique de Confidentialité de TikTok.
        </p>
        <p>
          Les Données TikTok sont collectées afin de (i) vous permettre de
          participer aux Campagnes TikTok et pour (ii) extraire des statistiques
          concernant votre activité Skeepers.
        </p>
        <p>
          Vos Données TikYok sont stockées dans les serveurs Skeepers et peuvent
          être partagées avec vous et des partenaires privilégiés de Skeepers à
          fin d'amélioration de la relation marque-influenceur, d'amélioration
          de l'expérience utilisateur et de statistiques.
        </p>
        <p>
          Vous pouvez révoquer l’accès de Skeepers à vos Données TikTok à tout
          moment via les réglages de sécurité de TikTok disponibles à l’adresse
          URL suivante :{' '}
          <a
            target="_blank"
            rel="noreferrer"
            href="https://support.tiktok.com/fr/account-and-privacy"
          >
            https://support.tiktok.com/fr/account-and-privacy
          </a>
        </p>
        <h2 className="fs-30">
          7. Transfert des Données / “DO NOT SHARE/SELL MY PERSONNAL DATA”
          (CCPA/CPRA)
        </h2>
        <p>
          Afin de permettre à Skeepers de suggérer des profils de Créateurs aux
          Clients, le nom, l'âge et le sexe de l'ensemble des Créateurs
          enregistrés sur la Plateforme seront automatiquement affichés au sein
          de la Plateforme lors de la création d'un compte Créateur de Skeepers.
        </p>
        <p>
          Skeepers peut, de temps à autre, vous contacter au nom de partenaires
          commerciaux externes afin de diffuser une offre particulière
          susceptible de vous intéresser. Dans de tels cas, les Données (adresse
          email, nom, adresse postale, numéro de téléphone) seront seulement
          transmises à ce tiers, y compris mais sans limitation, certaines
          informations reçues via votre connexion à la plateforme d'un réseau
          social, sous réserve de votre accord préalable.
        </p>
        <p>
          Afin d’assurer le bon fonctionnement de ses Services, Skeepers a
          recours aux services de sous-traitants ou prestataires (ex : ceux en
          charge de la maintenance du SI) tels des fournisseurs de services
          informatiques (ex : le prestataire d’hébergement), de solutions en
          mode SaaS qui ont besoin d’avoir accès à des Données pour exécuter la
          mission qui leur a été confiée par Skeepers. Skeepers impose à ces
          cocontractants des obligations fortes en matière de traitement,
          confidentialité et sécurité des Données auxquelles ces prestataires
          ont accès.
        </p>
        <p>
          Skeepers peut également partager les Données avec des partenaires de
          confiance afin de réaliser des analyses statistiques, vous envoyer un
          email ou un courrier, fournir un support client, ou assurer des
          livraisons des produits. Aucun tiers n'est autorisé à utiliser vos
          Données, sauf pour fournir lesdits services à Skeepers, et cela en
          garantissant de maintenir la stricte confidentialité des Données.
        </p>
        <p>
          Skeepers peut également être amenée à communiquer vos Données à des
          tiers dans certains cas particuliers :
        </p>
        <ul>
          <li>
            Si Skeepers envisage de céder une activité ou d’actifs (y compris
            par cession de l’entreprise exerçant cette activité ou possédant ces
            actifs), vos Données pourront être communiquées à l’acquéreur et à
            aux acquéreurs potentiels dans le cadre d’un audit y compris leurs
            conseils ;
          </li>
          <li>
            Si tout ou partie des actifs de Skeepers fait l’objet d’une
            acquisition par un tiers, les Données seront l’un des actifs
            transférés. Les Données seront traitées par l’acquéreur qui agira
            comme le nouveau responsable du traitement et sa politique de
            protection des Données régira alors le traitement des Données :
          </li>
          <li>
            Si Skeepers est obligée de divulguer ou donner accès aux Données
            pour se conformer à une obligation légale ou à une décision de
            justice, ou pour faire respecter ou appliquer le contrat de
            prestation ou toutes autres circonstances qu’acceptées, ou pour
            protéger les droits, la propriété ou la sécurité de Skeepers, de ses
            clients ou de ses collaborateurs ;
          </li>
          <li>Si la loi autorise ce transfert par Skeepers.</li>
        </ul>
        <p>
          <b>
            Vous disposez du droit de vous opposer, à tout moment, au transfert
            de vos données à des Tiers, qui ne sont pas des Prestataires
            auxquels Skeepers a recours pour la bonne exécution des Services
            proposés. Nous ne transmettrons alors plus vos données à ces Tiers,
            à moins de pouvoir vous justifier que nous avons des motifs
            légitimes et impérieux au transfert/traitement de vos données qui
            prévalent sur vos intérêts et vos droits et libertés, ou pour la
            constatation, l'exercice ou la défense de nos droits en justice.
            <br />
            Pour le partage des données avec les réseaux sociaux et les manières
            de s’y opposer, se référer au point 6. Données des réseaux.
            <br />
            Pour le dépôt de cookies et les manières de s’y opposer, se référer
            au point 8. Utilisation des Cookies/Publicité Ciblée.
            <br />
            Vente de vos données, cas particulier des Avis publiés sur la
            Plateforme : en soumettant votre Avis sur la Plateforme, vous
            autorisez Skeepers à vendre les informations que vous avez
            éventuellement fournies dans un Avis écrit sur un produit que vous
            avez testé, à des Marques susceptibles d'être intéressées. Si vous
            ne souhaitez pas que votre Avis soit vendu, il vous faut appuyer sur
            le bouton « Skip » et ne pas publier d’Avis.
            <br />
            En dehors de cette hypothèse, Skeepers ne vend pas vos Données.
          </b>
        </p>
        <h2 className="fs-30">8. Utilisation des Cookies/Publicité Ciblée</h2>
        <p>
          Skeepers ou les tiers autorisés par Skeepers (telles que les
          annonceurs ou les sociétés d'analyse de trafic), peuvent utiliser des
          procédés de traçage tels que des « cookies » afin de rendre votre
          expérience en ligne la plus personnalisée possible. Un cookie est un
          ensemble d’informations contenues dans un fichier déposé sur votre
          terminal (ordinateur, mobile) qui est lu par l'éditeur du site web ou
          de l’application mobile, et/ou par ses partenaires, à l'occasion de
          votre visite ou connexion sur nos sites ou applications mobiles : cela
          permet de <b>mémoriser certaines données de votre visite</b>. Les
          cookies ne peuvent pas exécuter de programmes ni propager de virus sur
          votre ordinateur. Un cookie vous est attribué de façon unique et ne
          peut être lu que par un serveur Web du domaine qui l'a émis. Pour plus
          d'information sur les cookies, merci de visiter les sites :
          www.allaboutcookies.org.
        </p>
        <p>
          Les cookies utilisés par Skeepers ont quatre fonctionnalités
          distinctes : ils sont (1) <b>nécessaires</b> au fonctionnement du site
          ou de l’application mobile (y compris par l’usage d’un réseau social),
          ou (2) permettent l’
          <b>analyse statistique</b> de l’audience ou (3) mesurent la{' '}
          <b>performance</b> publicitaire.
        </p>
        <p>
          <b>1/ Les cookies sont nécessaires au fonctionnement du site </b>
          ou de l’application mobile : ils ne nécessitent pas votre
          consentement, car ils sont <b>indispensables</b> : ces cookies sont{' '}
          <b>nécessaires</b> à votre authentification, à définir la langue dans
          laquelle nous diffusons nos contenus, à gérer le fonctionnement
          technique de nos sites et applications mobiles.
        </p>
        <p>
          <b>
            2/ Les cookies de réseau social sont nécessaires au fonctionnement
            du service Skeepers pour les influenceurs
          </b>{' '}
          car l’inscription des influenceurs requiert l’utilisation d’un réseau
          social (Instagram, Youtube, Facebook ou TikTok).
        </p>
        <ul>
          <li>
            Youtube:
            <a
              target="_blank"
              rel="noreferrer"
              href="https://www.youtube.com/intl/ALL_fr/howyoutubeworks/user-settings/privacy"
            >
              https://www.youtube.com/intl/ALL_fr/howyoutubeworks/user-settings/privacy
            </a>{' '}
          </li>
          <li>
            Facebook :{' '}
            <a
              target="_blank"
              rel="noreferrer"
              href="https://fr-fr.facebook.com/about/privacy"
            >
              https://fr-fr.facebook.com/about/privacy
            </a>{' '}
          </li>
          <li>
            Instagram :{' '}
            <a
              target="_blank"
              rel="noreferrer"
              href="https://privacycenter.instagram.com/policy"
            >
              https://privacycenter.instagram.com/policy
            </a>{' '}
          </li>
          <li>
            TikTok :{' '}
            <a
              target="_blank"
              rel="noreferrer"
              href="https://www.tiktok.com/legal/privacy-policy-eea?lang=fr"
            >
              https://www.tiktok.com/legal/privacy-policy-eea?lang=fr
            </a>{' '}
          </li>
        </ul>
        <p>
          <b>
            3/ Des cookies permettant de réaliser des analyses statistiques,{' '}
          </b>
          afin de comprendre votre utilisation de nos sites et services et de
          les améliorer.
        </p>
        <p>Il s’agit des cookies :</p>
        <ul>
          <li>
            <b>Hotjar</b> (uniquement sur le site Web) :{' '}
            <a
              target="_blank"
              rel="noreferrer"
              href="https://help.hotjar.com/hc/en-us/articles/115011789248-Hotjar-Cookie-Information"
            >
              https://help.hotjar.com/hc/en-us/articles/115011789248-Hotjar-Cookie-Information
            </a>{' '}
          </li>
          <li>
            <b>Google Analytics</b> (uniquement sur le site Web) :{' '}
            <a
              target="_blank"
              rel="noreferrer"
              href="https://developers.google.com/analytics/devguides/collection/analyticsjs/cookie-usage"
            >
              https://developers.google.com/analytics/devguides/collection/analyticsjs/cookie-usage
            </a>{' '}
          </li>
        </ul>
        <p>
          <b>
            4/ Des cookies permettant de mesurer l’efficacité de nos publicités
          </b>
        </p>
        <p>Il s’agit des cookies (uniquement sur les sites Web) :</p>
        <ul>
          <li>
            <b>Google Tag Manager : </b>
            <a
              target="_blank"
              rel="noreferrer"
              href="https://developers.google.com/tag-platform/tag-manager"
            >
              https://developers.google.com/tag-platform/tag-manager
            </a>{' '}
          </li>
        </ul>
        <p>
          <b>Quelles sont les informations auxquelles nous accédons ?</b>
        </p>
        <p>Nous accédons au :</p>
        <ul>
          <li>Type d’équipement que vous utilisez (Android, Apple, etc.)</li>
          <li>
            Type de système d’exploitation (Microsoft Windows, Linux, Android,
            iOS..)
          </li>
          <li>
            Type du logiciel de navigation Web (Internet Explorer, Safari,
            Chrome, etc.)
          </li>
          <li>Dates et heures de connexion à nos services</li>
          <li>
            Adresse de la page Internet d’où vous provenez avant de consulter
            notre site
          </li>
          <li>Données de navigation sur nos services</li>
          <li>Nombre de followers du réseau social des influenceurs</li>
        </ul>
        <p>
          <b>Quelle est la durée de vie des cookies ?</b>
        </p>
        <p>
          Le cookie a une durée de validité limitée à <b>13 mois maximum</b>,
          mais certains cookies ont une durée de vie moindre.
        </p>
        <p>
          Lorsque vous acceptez la pose et la lecture de cookies sur votre
          terminal, vous l’acceptez donc au maximum pour 13 mois.
        </p>
        <p>
          En revanche, lorsque vous refusez tous les cookies,
          <b>
            nous pourrons solliciter votre consentement à nouveau à l’issue
            d’une période de 6 mois.
          </b>
        </p>
        <p>
          Enfin, si vous continuez votre visite de nos sites et applications
          mobiles sans accepter, nous
          <b>pourrons solliciter votre consentement à votre prochaine visite</b>
          de nos sites et applications mobiles.
        </p>
        <p>
          Dans tous les cas, vous avez la possibilité de revenir sur votre
          consentement en vous rendant sur le lien «{' '}
          <b>Gestion du Consentement </b>» disponible en bas de chaque page du
          site ou dans l’onglet « <b>Paramètres</b> » de votre profil sur notre
          application mobile.
        </p>
        <p>
          Vous avez la possibilité d'accepter ou de refuser les cookies en
          indiquant votre choix sur la bannière d'information relative aux
          cookies s'affichant lorsque vous vous connectez au Site et/ou à la
          Plateforme. Si vous refusez les cookies, il est possible que vous ne
          puissiez pas profiter pleinement des fonctionnalités interactives des
          services de Skeepers ou des sites que vous visitez.
        </p>
        <p>
          Vous pouvez choisir de limiter la publicité comportementale sur le
          Site en cliquant sur http://www.aboutads.info/choices/ et en refusant
          le dépôt de cookies par les prestataires listés. Après avoir refusé,
          vous verrez encore des publicités mais celles-ci ne seront pas aussi
          pertinentes par rapport à vos intérêts. Si vous changez d'ordinateur
          ou de navigateur, ou si vous supprimez vos cookies, vous devrez
          renouveler votre refus.
        </p>
        <h2 className="fs-30">9. Durée de conservation des Données</h2>
        <p>
          Les Données (notamment celles relatives aux contrats conclus avec
          Skeepers) sont conservées pour une durée de 5 ans à compter de la
          réalisation de la prestation qu’il s’agisse de la réalisation d’une
          prestation mise en relation entre des Créateurs et des Marques ou pour
          toute prestation par un fournisseur. Toutefois :
        </p>
        <ul>
          <li>
            les Données des Créateurs sont conservées pendant toute la durée de
            leur activité sur leur espace Créateur. Elles seront anonymisées 6
            mois après la clôture de leur compte
          </li>
          <li>
            les Données des Créateurs sont supprimées dans un délai de 2 ans à
            compter de leur dernière activité sur leur compte
          </li>
          <li>
            en matière de précontentieux : les Données sont conservées jusqu’à
            la conclusion d’un protocole transactionnel ou, à défaut, jusqu’à la
            prescription de l’action en justice correspondante
          </li>
          <li>
            en matière de contentieux judiciaire : les Données sont conservées
            jusqu’à ce que la décision ait force de chose jugée définitive
          </li>
        </ul>
        <p>
          De manière générale, les Données ne sont conservées que le temps
          nécessaire à l’accomplissement de l’objectif poursuivi lors de leur
          collecte et en accord avec les recommandations de la CNIL et en
          respect des obligations légales notamment comptables et fiscales.
        </p>
        <p>
          En outre, les données anonymes et les données relatives aux Créateurs
          peuvent être conservées sans limitation de durée dès lors qu’elles ne
          contiennent aucune Donnée.<b> </b>
        </p>
        <p>
          <b></b>
          <br />
        </p>
        <h2 className="fs-30">
          10. Stockage des Données et les mesures de sécurité en place
        </h2>
        <p>
          L’ensemble de vos Données est hébergé chez Amazon Web Services aux
          Etats-Unis pour les Créateurs américains et au sein de l’Union
          Européenne pour les Créateurs européens (Irlande), en respect avec les
          règles applicables à ce type de transfert. En dehors des cas où le
          Créateur est basé à l’étranger, aucune donnée n’est transférée à un
          tiers situé à l’extérieur de l’Union Européenne, sauf dans le cas où
          Skeepers doit faire signifier et/ou exécuter des actes judiciaires
          (assignation, jugement, saisie…) à l’étranger du fait que le Créateur
          réside en dehors de l’Union Européenne. Dans ce cas les Données du
          Créateur sont transmises aux autorités en charge de signifier et/ou
          exécuter les actes. En tout état de cause, Skeepers s’assure que les
          Données transférées font l’objet d’une protection adéquate afin de
          garantir leur sécurité et leur intégrité.
        </p>
        <p>
          Vos Donnés sont uniquement conservées pour la durée strictement
          nécessaire aux finalités établies dans les précédents articles de la
          Privacy Policy. Au-delà de cette durée, les Données ne sont conservées
          qu'à des fins statistiques et d'archives, et ne sauraient être
          utilisées à d'autres fins. Une fois cette durée écoulée, vos Données
          sont détruites.
        </p>
        <p>
          Skeepers assure la sécurité de vos Données et prend toutes les
          précautions utiles pour garantir la confidentialité et la sécurité de
          vos Données et à en empêcher l’accès, l’utilisation, l’altération, la
          corruption, la divulgation, et/ou la destruction par des personnes non
          autorisées et prendra toutes les mesures nécessaires afin de limiter
          le risque de perte, de dommage, ou d'abus.
        </p>
        <p>
          Un Plan d’Assurance Sécurité et une Politique de Sécurité des Systèmes
          d’Information ont été mis en place. A titre, d’exemple, les accès à
          vos Données sont limités et restreints aux seules personnes/services
          qui ont besoin d’y accéder, qui ont signé un Accord de
          Confidentialité, ces Données sont stockées sur des serveurs sécurisés,
          vos Données sont chiffrées au transit et au repos. Les accès à vos
          Données nécessitent l’utilisation d’un identifiant et mot de passe
          fort.
        </p>
        <p>
          Néanmoins, la transmission de Données par le biais d’internet n’est
          pas sans risque, par conséquent Skeepers ne garantit pas la sécurité
          des Données transmises par internet dès lors que Skeepers aura
          respecté ses engagements en termes de sécurité.
        </p>
        <h2 className="fs-30">11. Vos droits</h2>
        <p>
          Dans le cadre du traitement de Données réalisé par Skeepers, vous avez
          le droit :
        </p>
        <ul>
          <li>D’obtenir l’accès / la copie de vos Données traitées</li>
          <li>D’obtenir la rectification de vos Données</li>
          <li>
            D’obtenir l’effacement de tout ou partie de vos Données lorsque les
            Données, (i) ne sont plus nécessaires aux finalités pour lesquelles
            elles ont été collectées, (ii) sont basées exclusivement sur le
            consentement, (iii) font l’objet d’une demande d’opposition
          </li>
          <li>
            De vous opposer aux traitements de vos Données du fait de votre
            situation particulière
          </li>
          <li>
            D’obtenir la limitation du traitement, temporairement, lorsque
            l’exactitude des Données est contestée, lorsque vous vous êtes
            opposé au traitement, lorsque vos Données ne sont plus nécessaires à
            Skeepers mais sont encore nécessaire à la constatation, l’exercice
            ou la défense de droits en justice
          </li>
          <li>
            De vous désinscrire ou de vous opposer à la réception de messages de
            prospection commerciale à tout moment en suivant les instructions de
            désinscription indiquées dans les emails promotionnels que vous
            recevez
          </li>
          <li>
            De retirer votre consentement à tout moment s’agissant de
            traitements fondés sur le consentement
          </li>
          <li>
            D’obtenir la portabilité de vos Données lorsque le traitement est
            fondé sur le consentement et que le traitement est effectué à l’aide
            de procédés automatisés
          </li>
          <li>
            De fournir des directives sur le sort de vos Données post-mortem
          </li>
        </ul>
        <p>
          Pour l’exercice de vos droits ou toute question relative à la présente
          Privacy Policy, vous pouvez adresser une demande à l’adresse suivante
          : <a href="mailto:privacy@skeepers.io">privacy@skeepers.io</a> ou par
          voie postale, à l’adresse indiquée ci-dessous :
        </p>
        <p>
          SKEEPERS
          <br />
          Legal Department - Data Protection Officer
          <br />
          18-20 Avenue Robert Schuman
          <br />
          CS 40494
          <br />
          13002 Marseille
        </p>
        <p>
          Pour toute demande d’exercice de droit, vous devez, dans votre message
          :
        </p>
        <ul>
          <li>
            Préciser l’adresse (mail ou postale) sur laquelle vous souhaitez
            obtenir une réponse de Skeepers ;
          </li>
          <li>
            Inclure un moyen permettant de vous identifier (numéro de commande,
            identifiant client, etc. si le moyen communiqué ne nous semble pas
            suffisant pour prouver votre identité, une copie de votre pièce
            d’identité pourra être exigée) ;
          </li>
          <li>Préciser, si possible :</li>
          <ul>
            <li>
              le contexte dans lequel la collecte de vos données a été
              effectuée,
            </li>
            <li>ainsi que la Solution concernée (Ici Influencer Marketing).</li>
          </ul>
        </ul>
        <p>
          Ces informations sont précieuses afin que la Data Protection Officer /
          Déléguée à la Protection des Données puisse vous répondre au plus
          vite.
        </p>
        <p>
          Skeepers vous informe qu’aucune demande ne sera traitée par téléphone.
        </p>
        <p>
          Une réponse vous sera formulée dans les meilleurs délais, qui ne
          pourront excéder un (1) mois à compter de la date de réception de
          votre demande.
        </p>
        <p>
          Une prolongation de deux (2) mois est possible, en cas de demande
          complexe, ou si un grand nombre de demandes ont été reçues.
        </p>
        <p>
          Votre demande, ainsi que toute donnée utile au traitement de votre
          demande, seront conservées pendant un délai de trois ans (cinq ans
          pour le droit d’opposition) à compter de la réception de votre
          demande. Si une pièce justificative vous a été demandée, ou que vous
          l’avez transmise de manière spontanée, cette dernière sera conservée
          pendant une durée d’un an.
        </p>
        <p>
          Si vous estimez, après avoir contacté la Data Protection Officer, et
          qu’un délai d’un mois se soit écoulé, que vos droits RGPD ne sont pas
          respectés, adresser une réclamation auprès de la CNIL.
        </p>
      </div>
    </div>
  )
}

export default PrivacyFr
